/**
 * Vendor import limits in the browser (vault 2026-10-31 vendor import
 * decisions, ruling 10). The server checks its own form of each again
 * (capture-app services/vendorRecord/importClassify.ts: 5,000 rows, 2,000,000
 * characters; middleware/jsonBody.ts: a 3 MB body).
 */
export const MAX_FILE_BYTES = 2 * 1024 * 1024;
export const MAX_ROWS = 5000;
export const MAX_REQUEST_BYTES = 3 * 1024 * 1024;
export const PARSE_TIMEOUT_MS = 20000;
export const SOURCE_MAX = 64;
